import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from '../../shared/i18n'
import Branch from './branch/Branch.module';
import Category from './category/Category.module';
import Department from './department/Department.module';
import Accounting from './accounting/Accounting.module';
import User from "./user/User.module";
import Templates from "./templates/Templates.module";
import SalesTaxConfiguration from "./sales-tax-configuration/SalesTaxConfiguration.module";
import DependedField from './depended-fields/DependedField.module';
import Cls from './cls/Cls.module';

MenuService.addMenuItem(new MenuItem('/setup', i18n.t('Setup'), 7, 'cog', [
  Branch.menuItem,
  Category.menuItem,
  Department.menuItem,
  User.menuItem,
  Accounting.menuItem,
  Templates.menuItem,
  SalesTaxConfiguration.menuItem,
  DependedField.menuItem,
  Cls.menuItem,
], 'setup'));

const routes = [
  ...Branch.routes,
  ...Category.routes,
  ...Department.routes,
  ...User.routes,
  ...Accounting.routes,
  ...Templates.routes,
  ...SalesTaxConfiguration.routes,
  ...DependedField.routes,
  ...Cls.routes
];

export {
  routes
}
